(function () {
	"use strict";

	const parallaxGallery = () => {
		var gsap = window.gsap;
		var ScrollTrigger = window.ScrollTrigger;

		gsap.registerPlugin(ScrollTrigger);

		function initZoomOutAnim() {
			var elements = document.querySelectorAll(".zoomOut");
			if (elements.length === 0) return false;

			var scaleValue = window.innerWidth <= 1024 ? 1.05 : 1.1;

			elements.forEach(function (element) {
				gsap.set(element, { scale: 1.25 });

				gsap.timeline({
					scrollTrigger: {
						trigger: element,
						start: "top 75%",
						lazy: true,
					},
				}).to(element, {
					scale: scaleValue,
					duration: 0.85,
					ease: "power1.inOut",
				});
			});
		}
		initZoomOutAnim();
	};

	document.addEventListener("DOMContentLoaded", function () {
		parallaxGallery();
		document.addEventListener("shopify:section:load", function () {
			parallaxGallery();
		});
	});
})();